import { render, staticRenderFns } from "./Version.vue?vue&type=template&id=ad01317a&"
import script from "./Version.vue?vue&type=script&lang=js&"
export * from "./Version.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/user/workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ad01317a')) {
      api.createRecord('ad01317a', component.options)
    } else {
      api.reload('ad01317a', component.options)
    }
    module.hot.accept("./Version.vue?vue&type=template&id=ad01317a&", function () {
      api.rerender('ad01317a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/Version.vue"
export default component.exports